declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_array_of_array_or_object_foo extends $mol_object {
		complex( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=array_of_array_or_object.view.tree.d.ts.map